import { useNextLocale } from '@captaincause/lib/useNextLocale'
import { SkeletonRectangle } from '@captaincause/ui/Skeletons/Rectangle'
import { Header } from 'components/DonatePanel/Header'
import { MobilePanelContainer } from 'components/DonatePanel/MobilePanelContainer'
import { DonateForm } from '../DonateForm'
import type { DonateMobileProps } from '..'

function DonateSkeletonMobile() {
  return (
    <>
      <SkeletonRectangle variant="huge" className="mb-4 h-[250px] w-full" />
      <SkeletonRectangle variant="large" className="mb-4 h-14 w-full" />
      <SkeletonRectangle variant="large" className="mb-4 h-20 w-full" />
      <SkeletonRectangle variant="medium" className="mb-4" />
      <SkeletonRectangle variant="large" className="mb-4 h-12 w-full" />
      <SkeletonRectangle variant="large" className="mb-4 h-12 w-full" />
      <SkeletonRectangle variant="large" className="mb-6" />
      <SkeletonRectangle variant="large" className="mb-4 h-16 w-full" />
    </>
  )
}
export function MobileView({
  isLoading,
  project,
  campaign,
  token,
}: DonateMobileProps) {
  const locale = useNextLocale()

  if (isLoading || !project) {
    return <DonateSkeletonMobile />
  }

  return (
    <MobilePanelContainer project={project} campaign={campaign}>
      <Header campaign={campaign} project={project} locale={locale} />
      <DonateForm
        project={project}
        campaign={campaign}
        token={token}
        locale={locale}
      />
    </MobilePanelContainer>
  )
}
